import { client } from "utils/api";

const getCnCodes = (q) =>
  new Promise(async (resolve) => {
    try {
      const { data } = await client.get(
        `/cn_codes?query=${encodeURIComponent(q || "")}`
      );
      const options = data.map(({ code, description_pl, full_path_pl }) => ({
        label: `${code} — ${full_path_pl}`,
        value: code,
        description_pl,
        full_path_pl,
      }));
      resolve(options);
    } catch (error) {
      console.log(error);
      resolve([]);
    }
  });

export default getCnCodes;
